import { Injectable } from '@angular/core';

@Injectable()
/**
 * Feature flags
 */
export class FirebaseConfig {

  public fuifi = {
    apiKey: 'AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU',
    authDomain: 'fuifi-2cd5b.firebaseapp.com',
    databaseURL: 'https://pro-mobilendo.firebaseio.com/',
    projectId: 'fuifi-2cd5b',
    storageBucket: 'fuifi-2cd5b.appspot.com',
    messagingSenderId: '272184507633',
    appId: '1:272184507633:web:9000a16a07d418a6',
    measurementId: 'G-7S2GECVMWB',
  };

  public fuifidev = {
    apiKey: 'AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU',
    authDomain: 'fuifi-2cd5b.firebaseapp.com',
    databaseURL: 'https://fuifi-2cd5b.firebaseio.com/',
    projectId: 'fuifi-2cd5b',
    storageBucket: 'fuifi-2cd5b.appspot.com',
    messagingSenderId: '272184507633',
    appId: '1:272184507633:web:9000a16a07d418a6',
    measurementId: 'G-7S2GECVMWB',
  };
  public laberitdev = {
    apiKey: 'AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU',
    authDomain: 'fuifi-2cd5b.firebaseapp.com',
    databaseURL: 'https://fuifi-2cd5b.firebaseio.com/',
    projectId: 'fuifi-2cd5b',
    storageBucket: 'fuifi-2cd5b.appspot.com',
    messagingSenderId: '272184507633',
    appId: '1:272184507633:web:9000a16a07d418a6',
    measurementId: 'G-7S2GECVMWB',
  };
  public laberit = {
    apiKey: "AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU",
  authDomain: "fuifi-2cd5b.firebaseapp.com",
  databaseURL: "https://pro-mobilendo.firebaseio.com/",
  projectId: "fuifi-2cd5b",
  storageBucket: "fuifi-2cd5b.appspot.com",
  messagingSenderId: "272184507633",
  appId: "1:272184507633:web:9000a16a07d418a6",
  measurementId: "G-7S2GECVMWB"
  };


  // public laberit = {
  //   apiKey: "AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU",
  // authDomain: "fuifi-2cd5b.firebaseapp.com",
  // databaseURL: "https://fuifi-2cd5b.firebaseio.com",
  // projectId: "fuifi-2cd5b",
  // storageBucket: "fuifi-2cd5b.appspot.com",
  // messagingSenderId: "272184507633",
  // appId: "1:272184507633:web:9000a16a07d418a6",
  // measurementId: "G-7S2GECVMWB"
  // };

  

  public startupv = {
    apiKey: 'AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU',
    authDomain: 'fuifi-2cd5b.firebaseapp.com',
    databaseURL: 'https://pro-mobilendo.firebaseio.com/',
    projectId: 'fuifi-2cd5b',
    storageBucket: 'fuifi-2cd5b.appspot.com',
    messagingSenderId: '272184507633',
    appId: '1:272184507633:web:9000a16a07d418a6',
    measurementId: 'G-7S2GECVMWB',
  };

  public soycolevisa = {
    apiKey: 'AIzaSyCNObH3R-i7dp9urFmn93C5fR0ePPtjBro',
    authDomain: 'soycolevisa.firebaseapp.com',
    databaseURL: 'https://soycolevisa.firebaseio.com/',
    projectId: 'soycolevisa',
    storageBucket: 'soycolevisa.appspot.com',
    messagingSenderId: '278888321992',
    appId: '1:278888321992:web:a5813ea47978db027ae6fd',
    measurementId: 'G-30PN2WF3QZ',
  };

  public colevisaempresas = {
    apiKey: 'AIzaSyABXKdjI37t6E9xXdZVQ60AwW6w4qdWhoU',
    authDomain: 'fuifi-2cd5b.firebaseapp.com',
    databaseURL: 'https://fuifi-2cd5b.firebaseio.com/',
    projectId: 'fuifi-2cd5b',
    storageBucket: 'fuifi-2cd5b.appspot.com',
    messagingSenderId: '272184507633',
    appId: '1:272184507633:web:9000a16a07d418a6',
    measurementId: 'G-7S2GECVMWB',
  };

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/services/firebaseConfig.ts